import React from 'react';
import { DialogContentText } from '@mui/material';
import Grid from '@mui/material/Grid';
import { ButtonV2Props, Dialog } from '@insights-ltd/design-library/components';

type ConfirmationDialogProps = {
  title: string;
  text: string;
  isOpen: boolean;
  onClose: () => void;
  primaryButtonText: string;
  dataTestId: string;
  svg?: React.ReactNode;
  primaryButtonColour?: ButtonV2Props['buttonColour'];
  secondaryButtonColour?: ButtonV2Props['buttonColour'];
  secondaryButtonText?: string;
  onSubmit?: () => void;
  onSecondarySubmit?: () => void;
};

const ConfirmationDialog = ({
  title,
  text,
  isOpen,
  onClose,
  svg,
  dataTestId,
  primaryButtonText,
  secondaryButtonText = '',
  primaryButtonColour,
  secondaryButtonColour,
  onSubmit,
  onSecondarySubmit,
}: ConfirmationDialogProps) => {
  return (
    <Dialog
      onClose={onClose}
      open={isOpen}
      title={title}
      content={
        <>
          {svg && (
            <Grid
              container
              sx={{
                justifyContent: 'center',
              }}
            >
              <Grid>{svg}</Grid>
            </Grid>
          )}
          <DialogContentText>{text}</DialogContentText>
        </>
      }
      dataTestId={dataTestId}
      primaryButtonText={primaryButtonText}
      primaryButtonColour={primaryButtonColour}
      onSubmit={onSubmit}
      secondaryButtonText={secondaryButtonText}
      secondaryButtonColour={secondaryButtonColour}
      onSecondarySubmit={onSecondarySubmit}
    />
  );
};

export default ConfirmationDialog;
